import React, { useRef } from "react";
import { DtDialog } from "../../ui/dialog";
import DtForm, { DtFormHandles } from "../../ui/form/DtForm";
import { FormField } from "../../ui/form/formTypes";
import { Button } from "@mui/material";

interface RespMessageDialogProps {
    open: boolean;
    mode: "add" | "edit" | "view";
    initialValues?: { ResponseMessage: string; ResponseOverride: string };
    onSave: (values: { ResponseMessage: string; ResponseOverride: string }) => void;
    onCancel: () => void;
    title?: string;
}

const RespMessageDialog: React.FC<RespMessageDialogProps> = ({
    open,
    mode,
    initialValues,
    onSave,
    onCancel,
    title,
}) => {
    const isView = mode === "view";
    const isEdit = mode === "edit";
    const formRef = useRef<DtFormHandles>(null);

    const fields: FormField[] = [
        {
            id: "ResponseMessage",
            label: "Response Message",
            type: "textarea",
            required: true,
            defaultValue: initialValues?.ResponseMessage ?? "",
            readOnly: isEdit || isView,
            size: 12,
            placeholder: "Enter response message",
        },
        {
            id: "ResponseOverride",
            label: "Response Message Override",
            type: "textarea",
            required: true,
            defaultValue: initialValues?.ResponseOverride ?? "",
            readOnly: isView,
            size: 12,
            placeholder: "Enter override message",
        },
    ];

    const handleAddOrSave = () => {
        formRef.current?.submit();
    };

    return (
        <DtDialog
            maxWidth="sm"
            open={open}
            onClose={onCancel}
            title={title ?? (mode === "add" ? "Add Response Message" : mode === "edit" ? "Edit Response Message" : "View Response Message")}
            actions={
                !isView && (
                    <>
                        <Button variant="outlined" size="small" type="button" onClick={onCancel}>
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            type="button"
                            style={{ marginRight: 8 }}
                            onClick={handleAddOrSave}
                        >
                            {mode === "add" ? "Add" : "Save"}
                        </Button>
                    </>
                )
            }
        >
            <DtForm
                ref={formRef}
                fields={fields}
                onSubmit={(data) => onSave(data as { ResponseMessage: string; ResponseOverride: string })}
                gap={2}
                labelPosition="ontop"
                showSubmit={false}
                showReset={false}
            />
        </DtDialog>
    );
};

export default RespMessageDialog;